import { FC } from 'react'

import { ISvgClass } from '../interface'

const ComputerIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M2 21C1.71667 21 1.47933 20.904 1.288 20.712C1.096 20.5207 1 20.2833 1 20C1 19.7167 1.096 19.4793 1.288 19.288C1.47933 19.096 1.71667 19 2 19H22C22.2833 19 22.5207 19.096 22.712 19.288C22.904 19.4793 23 19.7167 23 20C23 20.2833 22.904 20.5207 22.712 20.712C22.5207 20.904 22.2833 21 22 21H2ZM4 18C3.45 18 2.97933 17.8043 2.588 17.413C2.196 17.021 2 16.55 2 16V5C2 4.45 2.196 3.979 2.588 3.587C2.97933 3.19567 3.45 3 4 3H20C20.55 3 21.021 3.19567 21.413 3.587C21.8043 3.979 22 4.45 22 5V16C22 16.55 21.8043 17.021 21.413 17.413C21.021 17.8043 20.55 18 20 18H4ZM4 16H20V5H4V16Z"
        fill="inherit"
      />
    </svg>
  )
}

export default ComputerIcon
